/* eslint-disable no-dupe-keys */
/* eslint-disable jsx-a11y/scope */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect, useRef } from "react";
import Content from "../../../layout/content/Content";
import { Card, Spinner, FormGroup } from "reactstrap";
import {
    Button,
    Block,
    Row,
    Col,
    Icon,
} from "../../../components/Component";
import Swal from "sweetalert2";
import Head from "../../../layout/head/Head";
import ES5PA2Update from "./ES5PA2Update";
import { DownloadTableExcel } from 'react-export-table-to-excel';
import OptionCDisable from "../../components/DynmicOption/OptionCDisable.";
import * as xlsx from "xlsx";

const ES5PA2DataEdit = ({ ...props }) => {
    const [dataactive, setdataactive] = useState([]);
    /*const [Totall, setTotal] = useState([]);*/
    const [GTotal, setGTotal] = useState(0);
    const [Change, setchange] = useState(true);
    const [Totall2, setTotal2] = useState([]);
    const [Gloading, setGloading] = useState(false);
    const [userData, setuserData] = useState("");
    const month1 = ["Test", "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"]
    const [employmentId, setemloymentId] = useState(sessionStorage.getItem("employmentId"));
    const [Draft, setDraft] = useState(true);
    const today = new Date();
    const tableRef = useRef(null);
    const [loading, setloading] = useState(false);
    const [exportloading, setexportloading] = useState(false);
    const [formData, setFormData] = useState({
        EmploymentId: Number(props.employmentId),
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        month: sessionStorage.getItem("CurrentMonth") === null ? (today.getMonth() === 0 ? 12 : today.getMonth()) : sessionStorage.getItem("CurrentMonth"),
        dummymonth: sessionStorage.getItem("CurrentMonth") === null ? month1[today.getMonth()] : month1[sessionStorage.getItem("CurrentMonth")],
        year: sessionStorage.getItem("CurrentYear") === null ? (today.getMonth() === 0 ? today.getFullYear() - 1 : today.getFullYear()) : sessionStorage.getItem("CurrentYear"),
        EmploymentRefId: sessionStorage.getItem("EmploymentRefId"),
    });
    const onInputChange = (month, year) => {
        setFormData({ ...formData, month: month, year: year });

    };
    const Total = async (empId) => {

        const sendData = {

            EmploymentId: Number(empId),
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Data/GetES5pa2DetailsTotal1', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

                    //console.log(data[0])
                    /*setTotal(data[0])*/
                })


    };
    const Total2 = async (empId) => {

        const sendData = {

            EmploymentId: Number(empId),
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Data/GetES5pa2DetailsTotal2', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

                    //console.log(data[0])
                    setTotal2(data[0])
                })


    };
    const getdata2 = async () => {

        const sendData = {

            EmploymentRefId: Number(formData.EmploymentRefId),
        }


        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/Getparameters', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    /*console.log(data)*/
                    setdataactive(data)
                })


    };
    const getdata = async () => {

        const sendData = {
            EmploymentId: Number(employmentId),
            UserId: Number(localStorage.getItem("userId")),
        }


        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/Viewalldata', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

                    if (data === "NO") {
                        setloading(false)
                        setDraft(true)

                    }
                    else {
                        setloading(false)
                        setDraft(false)
                        setemloymentId(data.employmentId)
                        getdata2()
                        setuserData(data)
                        Total(data.employmentId)
                        Total2(data.employmentId)
                    }

                })


    };
    const generate = async () => {
        if (formData.year > 0 && formData.month > 0) {
            setloading(false)
            setGloading(true)
            const sendData = {
                UserId: Number(localStorage.getItem("userId")),
                EmploymentRefId: Number(formData.EmploymentRefId),
                YearId: Number(formData.year),
                MonthId: Number(formData.month),
            }
            ////console.log(sendData)

            await fetch(process.env.REACT_APP_API_LINK + 'api/Main/GenerateEs5pa2', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(sendData)

            })
                .then(response => response.json())
                .then(
                    data => {
                        if (data === "Error") {
                            Swal.fire({
                                title: ' This Month Report is Already Submitted',
                                icon: 'error',

                            })
                        } else {
                            setloading(false)
                            setGloading(false)
                            getdata()
                        }

                    })
        } else {
            Swal.fire({
                icon: "warning",
                title: "Month or Year Not Selected",
                text: "Please Select Month and Year",
                focusConfirm: false,
            }).then(() => {
                props.history.push("/Dashboard")
            })
        }


    };
    useEffect(() => {
        if (employmentId > 0) {
            Total(employmentId)
            Total2(employmentId)
            setchange(!Change)
        }
    }, [GTotal])
    useEffect(() => {

        setloading(true)
        getdata()
    }, [])
    const onFormSubmit = async () => {

        Swal.fire({
            title: 'Are You Sure you want to Submit  ?',
            icon: 'question',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Yes',
            confirmButtonColor: 'success',
            denyButtonText: `No`,
        }).then(async (result) => {

            if (result.isConfirmed) {
                const sendData = {

                    EmploymentId: employmentId,
                }

                //console.log(sendData)
                await fetch(process.env.REACT_APP_API_LINK + 'api/Main/Submitform', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(sendData)

                })
                    .then(response => response.json())
                    .then(
                        data => {
                            if (data === "Done") {
                                props.history.push("/Dashboard")
                            } else {
                                Swal.fire({
                                    title: 'Data Not Submitted',
                                    icon: 'error',

                                })
                            }

                        })


            } else if (result.isDenied) {
                getdata()
            }
        })



    };

    const onSaveDraft = async () => {

        Swal.fire({
            title: 'Data Saved Successfully',
            icon: 'success',

        })
        getdata()

    };
    const onSaveDraftGoBack = async () => {

        Swal.fire({
            title: 'Data Saved Successfully',
            icon: 'success',

        })
        props.history.push("/Dashboard")
        getdata()
    };

    const inputRef = useRef(null);

    const handleClick = () => {
        // 👇️ open file input box on click of another element
        inputRef.current.click();
    };

    //IMport Excel
    const readUploadFile = async (e) => {
        e.preventDefault();
        setexportloading(true);
        if (e.target.files) {
            const reader = new FileReader();
            reader.onload = async (e) => {
                const data = e.target.result;
                //console.log(data)
                const workbook = xlsx.read(data, { type: "array" });
                // //console.log(workbook)
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const json = xlsx.utils.sheet_to_json(worksheet);
                const paramLookup = new Map(dataactive.map((param) => [param.sno === "2.3.1" || param.sno === "2.3.2" ? (param.sno).trim() : Number((param.sno)), param.parametersId]));

                const senddata = json.map((item) => ({
                    ...item,
                    UserId: Number(localStorage.getItem("userId")),
                    ParametersID: paramLookup.get(item["S.No."]) || null,
                    EmploymentId: employmentId,
                }));
                /*console.log("JSON_SEND: ", senddata);*/
                const invalidEntry = senddata.find((item) => item.ParametersID === undefined);

                if (invalidEntry) {
                    setexportloading(false);

                    Swal.fire({
                        icon: 'error',
                        title: 'Upload Error!',
                        text: 'Some rows in your file are missing "S.No." values. Please check and try again.',
                        confirmButtonColor: '#d33',
                    });

                    return; // ⛔ Stop execution here
                }


                let hasError = false;

                try {
                    for (let i = 0; i < senddata.length; i++) {
                        const response = await fetch(
                            process.env.REACT_APP_API_LINK + "api/Main/UpdateDetailsES5PA2",
                            {
                                method: "POST",
                                headers: {
                                    Accept: "application/json",
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify(senddata[i]),
                            }
                        );

                        if (!response.ok) {
                            /*console.error(`Failed to update S.No. ${senddata[i]["S.No."]}`);*/
                            hasError = true;
                            break;
                        } else {
                            /* console.log(`Data for S.No. ${senddata[i]["S.No."]} updated successfully`);*/
                        }
                    }
                    setexportloading(false);
                    getdata();

                    if (hasError) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Upload Failed!',
                            text: 'One or more records failed to update. Please check your file or try again.',
                            showConfirmButton: true,
                            confirmButtonColor: '#d33',
                        });
                    } else {
                        Swal.fire({
                            icon: 'success',
                            title: 'Upload Successful!',
                            text: 'Your file has been processed and data updated.',
                            showConfirmButton: true,
                            confirmButtonColor: '#3085d6',
                            timer: 4000,
                        });
                    }

                } catch (error) {
                    console.error("Error updating data:", error);

                    // ❌ Show error Swal
                    Swal.fire({
                        icon: 'error',
                        title: 'Upload Failed!',
                        text: 'Something went wrong while updating the data.',
                        showConfirmButton: true,
                        confirmButtonColor: '#d33',
                    });
                    setexportloading(false);
                }
            };
            reader.readAsArrayBuffer(e.target.files[0]);

        }
    };

    const handleDownloadXlsx = () => {
        const link = document.createElement('a');

        // Set the download attribute with the file name
        link.download = 'ES5Part2 format.xlsx';

        // Set the href to the path of the file in the public folder
        link.href = '/Excel/ES5Part2.xlsx';

        // Trigger the download by simulating a click
        link.click();
    };

    return (
        <React.Fragment>
            <Head title="ES5-Part2-Edit" />
            {exportloading ? (
                <div className="loader-container">
                    <div className="spinner"></div>
                    < div className="message">Please wait while we upload the Excel Data and Do not Refresh the page ⌛ </div>

                </div>
            ) :
                <Content>
                    {loading ? <Spinner color="success" /> :
                        <Block>
                            <Button onClick={() => window.location.href = '/Dashboard'} color="dark"><em className="icon ni ni-back-alt"></em> BACK</Button>
                            <Card className="card-bordered card-stretch" style={{ padding: 20 }}>
                                {/* <NavbarDynamic />*/}
                                <div style={{ border: "2px solid black", padding: 10 }}>
                                    <Row className="gy-4" >
                                        <Col md="3">
                                            <h3>
                                                Employment Return (ES5 Part2) {" "}
                                            </h3>
                                        </Col>
                                      <Col md="3">
                                            <input
                                                style={{ display: "none" }}
                                                type="file"
                                                name="upload"
                                                id="upload"
                                                onChange={readUploadFile}
                                                ref={inputRef}
                                            />

                                            {Draft ? null : (
                                                <Button style={{ margin: "1.5rem" }} color="success">
                                                    <Icon className="icon ni ni-arrow-up-circle"></Icon>
                                                    <b
                                                        style={{ fontSize: 18 }}
                                                        onClick={() => handleClick()}
                                                    >
                                                        {" "}
                                                        Import Data from Excel{" "}
                                                    </b>
                                                </Button>
                                            )}
                                        </Col>
                                        <Col md="3">
                                            {/* Button for custom .xlsx download */}
                                            <Button style={{ margin: '1.5rem' }} color="info" onClick={handleDownloadXlsx}>
                                                <Icon className="icon ni ni-download"></Icon>
                                                <b style={{ fontSize: 18 }}>Download Excel Format</b>
                                            </Button>
                                        </Col>
                                        <Col md="3">
                                            <DownloadTableExcel
                                                filename="ES5Part2 Edit Report"
                                                sheet="users"
                                                currentTableRef={tableRef.current}
                                            >
                                                {Draft ? null : <Button style={{ float: "right", margin: '1.5rem' }} color="warning" ><Icon className="icon ni ni-download"></Icon><b style={{ fontSize: 18 }}>Export Excel</b></Button>}
                                            </DownloadTableExcel>{" "}
                                        </Col>
                                    </Row>
                                </div>

                                {Draft ? <Row className="gy-4">

                                    <Col md="6">
                                        <OptionCDisable onInputChange={onInputChange} namemain="year" mainid="year" />
                                    </Col>
                                    {Gloading === false ? <Col md="6">
                                        <Button color="success" onClick={() => generate()} >Generate</Button>
                                    </Col> : <Spinner color="success" />}
                                </Row> :
                                    <Card style={{ marginTop: 20, border: "2px solid black", padding: 10 }} className="card-bordered card-stretch">
                                        <Row className="gy-4">
                                            <Col md="6">
                                                <FormGroup>
                                                    <label className="form-label" htmlFor="Month">
                                                        Center: <label style={{ fontWeight: "normal" }}>  {userData.user !== undefined ? userData.user.state : "Not Specified"}</label>
                                                    </label>

                                                </FormGroup>
                                            </Col>
                                            <Col md="6">
                                                <FormGroup>
                                                    <label className="form-label" htmlFor="Month">
                                                        Name of Employment Exchange: <label style={{ fontWeight: "normal" }}>  {userData.user !== undefined ? userData.user.answer1 : "Not Specified"}</label>
                                                    </label>

                                                </FormGroup>
                                            </Col>
                                            <Col md="6">
                                                <FormGroup>
                                                    <label className="form-label" htmlFor="Month">
                                                        Month: <label style={{ fontWeight: "normal" }}> {month1[userData.monthId]}</label>
                                                    </label>

                                                </FormGroup>
                                            </Col>
                                            <Col md="6">
                                                <FormGroup>
                                                    <label className="form-label" htmlFor="Month">
                                                        ES 5 (Contd.): Return showing the work done in respect of Person with Disability (PWD): <label style={{ fontWeight: "normal" }}>  </label>
                                                    </label>

                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <div className="card-inner-group" style={{ border: '2px solid black', padding: 2 }}>

                                            <div style={{ height: window.innerHeight - 300, width: 'auto', overflow: 'scroll' }} className="table-responsive">
                                                <table className="table" style={{ borderCollapse: "separate", borderSpacing: 0 }}>
                                                    <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>
                                                        <tr >

                                                            <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                S. No.

                                                            </th>
                                                            <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                Item

                                                            </th>
                                                            <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                Cental Govt.

                                                            </th>
                                                            <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                Union Territory

                                                            </th>

                                                            <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                State Govt.

                                                            </th>
                                                            <th colSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >

                                                                Quasi Govt Estt/Public Sector Undertakings
                                                            </th>

                                                            <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >

                                                                Local Bodies
                                                            </th>
                                                            <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                Private Estt.
                                                            </th>
                                                            <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                Total
                                                            </th>


                                                        </tr>
                                                        <tr>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, }} ></td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, }} ></td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, }} ></td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, }} ></td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, }} ></td>
                                                            <td style={{ border: '1px solid black', padding: 10, minWidth: 80 }} ><b>Cental Govt</b></td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, }} ><b>State Govt</b></td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, }} ></td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, }} ></td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, }} ></td>
                                                        </tr>

                                                    </thead>

                                                    <tbody>

                                                        {dataactive.length > 0 ? dataactive.map((details) =>

                                                            details.parentId === 0 || details.parametersId === 94 ?
                                                                <tr scope="row" >

                                                                    <td >

                                                                        <b>  {details.sno}</b>

                                                                    </td>

                                                                    <td>
                                                                        <b>  {details.name}</b>



                                                                    </td>

                                                                </tr> :
                                                                details.parentId === -1 ?
                                                                    <tr scope="row" >

                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                            {details.sno}

                                                                        </td>

                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                            {details.name}

                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                                                            {Totall2.centalGovt3}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                                                            {Totall2.unionTerritory4}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                                                            {Totall2.stateGovt5}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                                                            {Totall2.centalGovt6}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                                                            {Totall2.stateGovt7}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                                                            {Totall2.localBodies8}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                                                            {Totall2.privateEstt9}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                                                            {Totall2.total10}
                                                                        </td>
                                                                    </tr>
                                                                    :
                                                                    <ES5PA2Update Change={Change} sno={details.sno} setGTotal={setGTotal} GTotal={GTotal} edit={true} name={details.name} parametersId={details.parametersId} employmentId={employmentId} ES5PA2Update={ES5PA2Update} />

                                                        ) : null}
                                                        {/*<tr scope="row" >

                                                        <td>

                                                            <b>  </b>

                                                        </td>

                                                        <td>

                                                            <b>  Total</b>

                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.centalGovt3}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.unionTerritory4}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.stateGovt5}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.centalGovt6}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.stateGovt7}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.localBodies8}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.privateEstt9}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.total10}
                                                        </td>
                                                    </tr>*/}

                                                    </tbody>
                                                </table>

                                            </div>

                                            <div style={{ visibility: 'hidden', height: 0, width: 0 }} className="table-responsive">
                                                <table className="table" ref={tableRef} style={{ borderCollapse: "separate", borderSpacing: 0 }}>
                                                    <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>
                                                        <tr >

                                                            <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                S. No.

                                                            </th>
                                                            <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                Item

                                                            </th>
                                                            <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                Cental Govt.

                                                            </th>
                                                            <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                Union Territory

                                                            </th>

                                                            <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                State Govt.

                                                            </th>
                                                            <th colSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >

                                                                Quasi Govt Estt/Public Sector Undertakings
                                                            </th>

                                                            <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >

                                                                Local Bodies
                                                            </th>
                                                            <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                Private Estt.
                                                            </th>
                                                            <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                Total
                                                            </th>


                                                        </tr>
                                                        <tr>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, }} ></td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, }} ></td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, }} ></td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, }} ></td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, }} ></td>
                                                            <td style={{ border: '1px solid black', padding: 10, minWidth: 80 }} ><b>Cental Govt</b></td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, }} ><b>State Govt</b></td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, }} ></td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, }} ></td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, }} ></td>
                                                        </tr>

                                                    </thead>

                                                    <tbody>

                                                        {dataactive.length > 0 ? dataactive.map((details) =>

                                                            details.parentId === 0 || details.parametersId === 94 ?
                                                                <tr scope="row" >

                                                                    <td >

                                                                        <b>  {details.sno}</b>

                                                                    </td>

                                                                    <td>
                                                                        <b>  {details.name}</b>



                                                                    </td>

                                                                </tr> :
                                                                details.parentId === -1 ?
                                                                    <tr scope="row" >

                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                            {details.sno}

                                                                        </td>

                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                            {details.name}

                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                                                            {Totall2.centalGovt3}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                                                            {Totall2.unionTerritory4}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                                                            {Totall2.stateGovt5}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                                                            {Totall2.centalGovt6}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                                                            {Totall2.stateGovt7}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                                                            {Totall2.localBodies8}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                                                            {Totall2.privateEstt9}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                                                            {Totall2.total10}
                                                                        </td>
                                                                    </tr>
                                                                    :
                                                                    <ES5PA2Update Change={Change} sno={details.sno} setGTotal={setGTotal} GTotal={GTotal} edit={false} name={details.name} parametersId={details.parametersId} employmentId={employmentId} ES5PA2Update={ES5PA2Update} />

                                                        ) : null}
                                                        {/*<tr scope="row" >

                                                        <td>

                                                            <b>  </b>

                                                        </td>

                                                        <td>

                                                            <b>  Total</b>

                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.centalGovt3}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.unionTerritory4}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.stateGovt5}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.centalGovt6}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.stateGovt7}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.localBodies8}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.privateEstt9}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.total10}
                                                        </td>
                                                    </tr>*/}

                                                    </tbody>
                                                </table>

                                            </div>



                                        </div>
                                        <div style={{ marginTop: 30, marginRight: -10 }}>
                                            <Button color='info' onClick={() => onSaveDraft()}>Save As Draft<em className="icon ni ni-unarchive"></em></Button>  <Button onClick={onFormSubmit} color='success'>Submit <em className="icon ni ni-file-check"></em></Button> <Button color='warning' onClick={() => onSaveDraftGoBack()}>Save As Draft And Back To Dashboard<em className="icon ni ni-signout"></em></Button>
                                        </div>
                                    </Card>}



                            </Card>

                        </Block>}

                </Content>
            }
        </React.Fragment>
    );
};

export default ES5PA2DataEdit;
